import { Paper, Stack } from '@mui/material';
import { ContainmentField } from 'components';
import * as hooks from 'lib/hooks';
import { ElevatedPaperStyle } from 'lib/styles/shared';
import { ComponentTitle } from './ComponentTitle';

export const ContainmentHeader = () => {
	const { f } = hooks.UseFormContext();
	const partNumber = f.getValues('partNumber');
	const duns = f.getValues('duns');

	// Show component if partNumber exists (for both RESS and GPS single-part containments)
	if (!partNumber) {
		return null;
	}

	return (
		<Stack direction="column" justifyContent="center">
			<Paper sx={ElevatedPaperStyle}>
				<Stack direction="column" alignItems="center">
					<ComponentTitle title="Containment Details" />

					<ContainmentField
						title="Part Number"
						value={partNumber}
					/>

					{/* DUNS is only shown for RESS single-part containments */}
					{duns.IfSome((dun) => (
						<ContainmentField title="Supplier DUNs" value={dun.DUNName} />
					)).UnwrapOrNil()}
				</Stack>
			</Paper>
		</Stack>
	);
};
